<template>
  <div class="home-page">
    <div class="home-card">
      <h1>金蝶艺术展陈系统</h1>
      <p class="subtitle">请选择要进入的页面</p>

      <div class="button-group">
        <button @click="goBackend">进入后台管理</button>

        <button class="secondary" @click="goExhibit">查看展品页面</button>
      </div>
    </div>

    <div class="icp-footer">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        粤ICP备2026074172号-1
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",

  methods: {
    goBackend() {
      window.location.href = "/backend/";
    },

    goExhibit() {
      this.$router.push({
        path: "/exhibitList",
      });
    },
  },
};
</script>

<style scoped>
.home-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa, #e8ecf3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 64px;
  box-sizing: border-box;
}

.home-card {
  width: 420px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.home-card h1 {
  margin: 0;
  font-size: 28px;
  color: #222;
  font-weight: 600;
}

.subtitle {
  margin: 16px 0 32px;
  color: #666;
  font-size: 16px;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

button {
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #1677ff;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #0958d9;
}

button.secondary {
  background: #f0f2f5;
  color: #333;
}

button.secondary:hover {
  background: #d9d9d9;
}

.icp-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  text-align: center;
  font-size: 13px;
  color: #999;
}

.icp-footer a {
  color: #999;
  text-decoration: none;
}

.icp-footer a:hover {
  color: #666;
  text-decoration: underline;
}
</style>
